export const getEntitiesByUnionArray = <U extends { __typename?: string }>(
  responses: (U | { __typename?: string; [key: string]: unknown })[],
  typename: U['__typename']
): U[] => responses.filter((elem): elem is U => elem.__typename === typename)

type GraphQLEntity = { __typename: string }

export const getTypename = <T extends GraphQLEntity>(
  response: T
): T['__typename'] => {
  return response.__typename
}

export const defineResponseHandlers = <T extends GraphQLEntity, R>(defines: {
  [key in T['__typename']]: (result: Extract<T, { __typename: key }>) => R
}) => {
  return (input: T): R => {
    const typename = getTypename(input)
    const handler = defines[typename]

    if (!handler) {
      // 型で全部網羅しているので、ここには来ないはずだが一応
      throw new Error(`handler not found for ${typename}`)
    }

    return handler(input as Extract<T, GraphQLEntity>)
  }
}
